import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import actions from "./storeActions"
import state from "./storeState"
import mutations from "./storeMutations"
import getters from "./storeGetters"

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters
})
